import { get, omitBy } from 'lodash';
import apiClient from 'api';
import { getAllowedProperties } from 'api/utils';

const authServerBaseUrl = window.env.REACT_APP_SERVER_API_PATH;
const EDIT_OWN_ACCOUNT_PROPERTIES = [
  'firstName',
  'lastName',
  'email',
  'password'
];
const EDIT_USER_PROPERTIES = ['firstName', 'lastName', 'roleId'];

export const fetchAuthenticatedUser = async userId => {
  return await apiClient.get(authServerBaseUrl, `/user`);
};

export const editAuthenticatedUser = async (id, updatedUserInfo) => {
  let filteredPayload = getAllowedProperties(
    updatedUserInfo,
    EDIT_OWN_ACCOUNT_PROPERTIES
  );
  filteredPayload = omitBy(
    filteredPayload,
    value => value === null || value === ''
  );
  const { email, password, oldPassword } = updatedUserInfo;

  if (email) {
    filteredPayload.email = email;
  }
  if (password) {
    filteredPayload.password = password;
  }
  if (oldPassword) {
    filteredPayload.oldPassword = oldPassword;
  }
  const response = await apiClient.put(
    authServerBaseUrl,
    `/user`,
    filteredPayload
  );
  return response;
};

export const getUsers = async () => {
  return await apiClient.get(authServerBaseUrl, `/users`);
};

const getRoleId = async roleName => {
  const authRoles = await apiClient.get(authServerBaseUrl, `/roles`);
  const assignedRole = get(authRoles, 'roles', []).find(
    authRole => authRole.roleName === roleName
  );

  if (!assignedRole || !assignedRole.id) {
    throw new Error('Invalid role assigned');
  }

  return assignedRole.id;
};

export const createUser = async user => {
  const { firstName, lastName, email, password, role } = user;

  const authRoles = await apiClient.get(authServerBaseUrl, `/roles`);
  const assignedRole = get(authRoles, 'roles', []).find(
    authRole => authRole.roleName === role
  );

  if (!assignedRole) {
    throw new Error('Invalid role assigned');
  }

  const newUserPayload = {
    firstName: firstName,
    lastName: lastName,
    email,
    password,
    roleId: assignedRole.id.toString()
  };

  return await apiClient.post(authServerBaseUrl, `/users`, newUserPayload);
};

export const editUser = async user => {
  const { id, firstName, lastName, role } = user;

  const roleId = await getRoleId(role);

  const userInfo = {
    firstName: firstName,
    lastName: lastName,
    roleId: roleId.toString()
  };

  let filteredPayload = getAllowedProperties(userInfo, EDIT_USER_PROPERTIES);
  filteredPayload = omitBy(
    filteredPayload,
    value => value === null || value === ''
  );

  return await apiClient.put(
    authServerBaseUrl,
    `/users/${id}`,
    filteredPayload
  );
};

export const removeUser = async user => {
  return await apiClient.delete(authServerBaseUrl, `/users/${user.id}`);
};
